import * as angular from "angular";
import { DialogUtils } from "../../../helper/dialog.helper";

let CanvasserComponent = {
    selector: "vcCanvasser",
    templateUrl: "/angular/components/canvass/modals/canvasser.component.html",
    bindings: {
        selectedUser: "=",
    },
    controller: class CanvasserController {
        // * bindings for typescript compiler *
        public selectedUser: any;
        // ************************************
        private dialog: DialogUtils;

        constructor(DialogUtils: DialogUtils) {
            this.dialog = DialogUtils;
        }

        confirm(): void {
            this.dialog.hide(this.selectedUser);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("canvass")
    .component(CanvasserComponent.selector, CanvasserComponent);
